import React, { useState, useEffect } from "react";
import { Tabs, Tab, Row, Col, Table, Button, Form } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import BackImg from "../assets/images/cart/back-icon.svg";

import { useDispatch, useSelector } from "react-redux";
import {
  clearOrderReturnMessages,
  getReturnReasonOption,
  fetchStoreAddresses,
  createReturnOrder,
} from "../features/order_return/orderReturnActions";
import { clearLocalCheckout } from "../features/checkout/checkoutActions";

import { toast } from "react-toastify";
import {
  formatPrice,
  formatDate,
  addressStringCreate,
} from "../helpers/helpers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

function ReturnOrdersDetails({ toggleReturnOrders }) {
  const [returnItem, setReturnItem] = useState(null);
  const [selectedReturnOption, setSelectedReturnOption] = useState("");
  const [selectedReturnAddress, setSelectedReturnAddress] = useState("");

  const [returnRefundTitle, setReturnRefundTitle] = useState(null);
  const [returnRefundTitleDescription, setReturnRefundTitleDescription] =
    useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    loading,
    errorMessage,
    successMessage,
    returnReasons,
    storeAddresses,
  } = useSelector((state) => state.order_return);

  useEffect(() => {
    dispatch(getReturnReasonOption());
    dispatch(fetchStoreAddresses());

    let localReturnItem = localStorage.getItem("return_item");
    setReturnItem(JSON.parse(localReturnItem));

    const checkLocalStorage = setInterval(() => {
      let localFooterContent = localStorage.getItem("footerSection");
      if (localFooterContent) {
        let localFooterContentJson = JSON.parse(localFooterContent);
        setReturnRefundTitle(localFooterContentJson?.return_title);
        setReturnRefundTitleDescription(
          localFooterContentJson?.return_description
        );
        clearInterval(checkLocalStorage); // Stop the interval once data is found
      }
    }, 1000); // Check every second

    return () => clearInterval(checkLocalStorage); // Cleanup on unmount
  }, [dispatch]);

  useEffect(() => {
    if (returnReasons.data?.length > 0) {
      setSelectedReturnOption(returnReasons.data[0].title);
    }
  }, [returnReasons]);

  useEffect(() => {
    if (storeAddresses.data?.length > 0) {
      setSelectedReturnAddress(storeAddresses.data[0]);
    }
  }, [storeAddresses]);

  const [activeKey, setActiveKey] = useState("RODStepOne");
  const tabKeys = ["RODStepOne", "RODStepTwo", "RODStepThree"];

  const handleNext = () => {
    const currentIndex = tabKeys.indexOf(activeKey);
    if (currentIndex < tabKeys.length - 1) {
      setActiveKey(tabKeys[currentIndex + 1]);
    }
  };

  const handleSubmitForm = () => {
    let formData = {
      return_item: localStorage.getItem("return_item"),
      return_reason: selectedReturnOption,
      store_address: JSON.stringify(selectedReturnAddress),
    };
    dispatch(createReturnOrder(formData));
  };

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage, {
        autoClose: 5000,
        hideProgressBar: true,
        className: "toast-success"
      });
      dispatch(clearOrderReturnMessages());
      dispatch(clearLocalCheckout());
      setTimeout(() => {
        navigate("/profile/return-orders");
        window.location.reload();
      }, 2500);
    }
    if (errorMessage) {
      toast.error(errorMessage, { autoClose: 5000, hideProgressBar: true, className: "toast-error" });
      dispatch(clearOrderReturnMessages());
    }
  }, [dispatch, navigate, errorMessage, successMessage]);

  // const handleBack = () => {
  //   const currentIndex = tabKeys.indexOf(activeKey);
  //   if (currentIndex > 0) {
  //     setActiveKey(tabKeys[currentIndex - 1]);
  //   }
  // };

  // const handleCancel = () => {
  //   setActiveKey("RODStepOne");
  // };

  return (
    <>
      <section className="return-orders-details">
        <div className="return-orders-details-wrap">
          <div className="tab-content-header">
            <h3>
              <Link to="" onClick={toggleReturnOrders} className="backToList">
                <img src={BackImg} alt="" />
              </Link>{" "}
              Back to Orders
            </h3>
          </div>
          <Row>
            <Col lg="12" xl="8">
              <div className="return-orders-details-left">
                <Tabs
                  activeKey={activeKey}
                  onSelect={(k) => setActiveKey(k)}
                  className="mb-3"
                >
                  <Tab
                    eventKey="RODStepOne"
                    title="Why are you returning this?"
                  >
                    {returnReasons?.data?.length > 0 && (
                      <>
                        {returnReasons?.data?.map((item, index) => (
                          <div key={index} className="radio-group">
                            <div className="return-orders-wrap">
                              <Form.Check
                                type="radio"
                                name="returning-list"
                                checked={item.title === selectedReturnOption}
                                className="form-check custom-checkbox"
                                id={`reason-${index}`}
                                onChange={() =>
                                  setSelectedReturnOption(item.title)
                                }
                              />
                              <label
                                for={`reason-${index}`}
                                className="radio-info"
                              >
                                <h3>{item.title}</h3>
                              </label>
                            </div>
                          </div>
                        ))}
                      </>
                    )}

                    <div className="d-flex justify-content-start bttn-group">
                      <Button
                        className="cutsom-bttn cancel-bttn"
                        onClick={toggleReturnOrders}
                      >
                        Cancel
                      </Button>
                      <Button className="cutsom-bttn" onClick={handleNext}>
                        Next
                      </Button>
                    </div>
                  </Tab>

                  <Tab eventKey="RODStepTwo" title="How can we make it right?">
                    <div className="refund-your-bank-account">
                      <h5>{returnRefundTitle}</h5>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: returnRefundTitleDescription,
                        }}
                      ></div>
                    </div>
                    <div className="d-flex justify-content-start bttn-group">
                      <Button
                        className="cutsom-bttn cancel-bttn"
                        onClick={toggleReturnOrders}
                      >
                        Cancel
                      </Button>
                      <Button className="cutsom-bttn" onClick={handleNext}>
                        Next
                      </Button>
                    </div>
                  </Tab>

                  <Tab
                    eventKey="RODStepThree"
                    title="How would you like to return your item?"
                  >
                    <div className="address-method">
                      <div className="address-method-body">
                        {storeAddresses?.data?.length > 0 && (
                          <>
                            {storeAddresses?.data.map((item, index) => (
                              <div key={index} className="radio-group">
                                <div className="gender-group">
                                  <Form.Check
                                    onChange={() =>
                                      setSelectedReturnAddress(item)
                                    }
                                    type="radio"
                                    name="address"
                                    checked={
                                      item.id === selectedReturnAddress.id
                                    }
                                    className="form-check custom-checkbox"
                                    id={`address-${index}`}
                                  />
                                  <div className="radio-info">
                                    <h3>
                                      {item.first_name + " " + item.last_name}
                                    </h3>
                                    <p>{addressStringCreate(item)}</p>
                                  </div>
                                  {item.shipping_amount > 0 ? (
                                    <p className="edit-address">
                                      {returnItem?.product.currency}{" "}
                                      {formatPrice(item.shipping_amount)}
                                    </p>
                                  ) : (
                                    <p className="edit-address">Free</p>
                                  )}
                                </div>
                              </div>
                            ))}
                          </>
                        )}
                      </div>
                    </div>
                    <div className="d-flex justify-content-start bttn-group">
                      <Button
                        className="cutsom-bttn cancel-bttn"
                        onClick={toggleReturnOrders}
                      >
                        Cancel
                      </Button>
                      <Button
                        disabled={loading}
                        className="cutsom-bttn"
                        onClick={() => handleSubmitForm()}
                      >
                        {loading ? (
                          <FontAwesomeIcon
                            icon={faSpinner}
                            spin
                            size="lg"
                            className="spinner-icon"
                          />
                        ) : (
                          "Confirm Your Return"
                        )}
                      </Button>
                    </div>
                  </Tab>
                </Tabs>
              </div>
            </Col>
            <Col lg="12" xl="4">
              <div className="summary-box order-summary-box">
                <div className="box-header">
                  <h3>Items you’re returning</h3>
                </div>
                {returnItem && (
                  <div className="cart-box">
                    <div className="cart-box-img">
                      <Link to={"/products/" + returnItem?.product.slug}>
                        <img
                          src={`${process.env.REACT_APP_PHP_BACKEND_MEDIA_URL}${returnItem.product.image}`}
                          alt={returnItem.product.title}
                        />
                      </Link>
                    </div>
                    <div className="cart-box-content">
                      <span>{returnItem.product.category_title}</span>
                      <h2>
                        <Link to={"/products/" + returnItem?.product.slug}>
                          {returnItem.product.title}
                        </Link>
                      </h2>
                      <Link
                        to={"/products/" + returnItem?.product.slug}
                        className="price-value"
                      >
                        {" "}
                        {returnItem?.product.currency}{" "}
                        {formatPrice(returnItem.total_selling_price)}
                      </Link>
                      <p className="return-text">
                        Return eligible through{" "}
                        {formatDate(returnItem.return_eligible_last_date)}
                      </p>
                    </div>
                  </div>
                )}
                <div className="box-header">
                  <h3>Summary</h3>
                  <p>
                    You will receive a total refund of{" "}
                    {returnItem?.product.currency}
                    {formatPrice(returnItem?.total_selling_price)}.
                  </p>
                </div>
                <h4>Refund Summary</h4>
                <Table>
                  <tbody>
                    <tr>
                      <td>Refund Total</td>
                      <td>
                        {returnItem?.product.currency}
                        {formatPrice(returnItem?.total_selling_price)}
                      </td>
                    </tr>
                    {selectedReturnAddress.shipping_amount > 0 && (
                      <tr>
                        <td>Shipping</td>
                        <td className="discounts">
                          {returnItem?.product.currency}
                          {formatPrice(selectedReturnAddress.shipping_amount)}
                        </td>
                      </tr>
                    )}

                    <tr>
                      <th>Total estimated refund</th>
                      <th>
                        {returnItem?.product.currency}
                        {formatPrice(returnItem?.total_selling_price)}
                      </th>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </Col>
          </Row>
        </div>
      </section>
    </>
  );
}
export default ReturnOrdersDetails;
